const OptionSpec = require('./build/contracts/Option.json');
const OptionalitySpec = require('./build/contracts/Optionality.json');
const DutchAuctionSpec = require('./build/contracts/DutchAuction.json');

const FaucetSpec = require('./build/contracts/Faucet.json');
const ERC20Spec = require('./build/contracts/DetailedERC20.json');
const Bytes32ERC20Spec = require('./build/contracts/Bytes32ERC20.json');

module.exports = {
  OptionSpec: OptionSpec,
  OptionalitySpec: OptionalitySpec,
  DutchAuctionSpec: DutchAuctionSpec,
  FaucetSpec: FaucetSpec,
  ERC20Spec: ERC20Spec,
  Bytes32ERC20Spec: Bytes32ERC20Spec
}


//////////////////
// WEBPACK FOOTER
// ../optionality/index.js
// module id = 498
// module chunks = 0